import { AppState } from '../../..';
import { connect, Dispatch } from 'react-redux';
import { SummaryComponent, SummaryProperties } from './summary.component';
import { ContractViewModel } from '@models/Contract';
import { saveContract, savePaymentInfo } from '../../contract.actions';
import { ModalProps } from '@common/components/modal';
import { toggleModal } from '@common/components/common.actions';
import { saveResaleContract } from '../../contract-resale.actions';
import { ContractPaymentConfirmation } from '../contract-payment/_components/confirmation';
import { getRoute, RouteDefinitions } from '@common/route-definitions';
import { history } from '../../..';
import { saveComment } from 'src/comments/comments.actions';
import { CommentType, CommentViewModel } from '@models/Comment';
import { OptionsViewModel } from '@models/common.models';
import { actions } from 'react-redux-form';
import FormNames from '@constants/FormNames.enum';
/*
This is the container for the component.
This "connects" the redux and react layers by translating the state of the page into props for the component.
It also wires up the actions so the component can emit them.
*/

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: {
    buttonRef: (button: HTMLButtonElement) => void;
    next: Function;
    jump: Function;
    currentStep: number;
    isRenewal: boolean;
  }
): Partial<SummaryProperties> {
  return {
    message: state.contract.message,
    currentStep: ownProps.currentStep,
    contractVM: state.contract.contractVM,
    additionalRealEstateAgents: state.contract.additionalRealEstateAgents,
    contactInitiators: state.contract.contactInitiators,
    contactMediums: state.contract.contactMediums,
    contactTypes: state.contract.contactTypes,
    propertyTypes: state.contract.propertyTypes,
    propertySaleTypes: state.contract.propertySaleTypes,
    billingOptions: state.contract.billingOptions,
    coverageOptions: (state.contract.contractVM || ({} as ContractViewModel)).coverageOptions || [],
    assetManagers: state.contract.assetManagers,
    buyerCustomer: state.contract.buyerCustomer,
    sellerCustomer: state.contract.sellerCustomer,
    propertyManager: state.contract.propertyManager,
    initAgent: state.contract.initAgent,
    coopAgent: state.contract.coopAgent,
    initOffice: state.contract.initOffice,
    coopOffice: state.contract.coopOffice,
    totalPrice: state.contract.totalPrice,
    escrowOfficer: state.contract.escrowOfficer ? state.contract.escrowOfficer : undefined,
    escrowOffice: state.contract.escrowOffice ? state.contract.escrowOffice : undefined,
    buttonRef: ownProps.buttonRef,
    transactionCoordinator: state.contract.transactionCoordinator,
    isRenewal: ownProps.isRenewal,
    totalAdjustment: state.contract.totalAdjustment,
    orderType: state.contract.orderType,
    tempComment:
      state.forms &&
      state.forms.commentForm &&
      state.forms.commentForm.comment &&
      state.forms.commentForm.comment.value,
    tempUsers: state.comment.usersToAction
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: { buttonRef: (button: HTMLButtonElement) => void; next: Function; jump: Function }
): Partial<SummaryProperties> {
  return {
    onSaveClick: (
      contractVM: ContractViewModel,
      isRenewal?: boolean,
      tempComment?: string,
      tempUsers?: OptionsViewModel[]
    ) => {
      if (isRenewal) {
        if (contractVM.totalPrice < 0) {
          dispatch(
            saveContract(contractVM, (contractId: number) => {
              dispatch(
                savePaymentInfo(contractId, undefined, false, () => {
                  dispatch(
                    toggleModal({
                      title: 'Contract renewal completed.',
                      component: ContractPaymentConfirmation,
                      childProps: {
                        contractId: contractId,
                        refundAmount: contractVM.totalPrice
                        // alternateText: 'The following amount will be refunded for this renewal contract (' + contractId + '): $' + contractVM.totalPrice
                      },
                      closeLabel: 'Close',
                      closeCallback: () => {
                        history.push('/');
                      },
                      saveLabel: 'View Contract Details',
                      saveCallback: () => {
                        dispatch(toggleModal());
                        history.push(getRoute(RouteDefinitions.contract.Details, { id: contractId }));
                      },
                      isSmall: true
                    })
                  );
                })
              );
              if (tempComment) {
                dispatch(
                  saveComment(
                    contractId,
                    CommentType.Contract,
                    { comment: tempComment } as CommentViewModel,
                    tempUsers ? tempUsers : []
                  )
                );
              }
            })
          );
        } else {
          ownProps.next();
        }
      } else {
        if (contractVM.resaleId) {
          dispatch(saveResaleContract(contractVM)).then(() => {
            ownProps.next();
          });
        } else {
          dispatch(
            saveContract(contractVM, (contractId: number) => {
              if (tempComment) {
                dispatch(
                  saveComment(
                    contractId,
                    CommentType.Contract,
                    { comment: tempComment } as CommentViewModel,
                    tempUsers ? tempUsers : []
                  )
                );
              }
              ownProps.next();
            })
          );
        }
      }
    },
    jump: step => {
      ownProps.jump(step);
    },
    toggleModalAndValidate: (modalProps: ModalProps, tempComment?: string) => {
      dispatch(actions.blur(`${FormNames.CommentForm}.comment`));
      if (tempComment && tempComment.length > 0) {
        dispatch(toggleModal(modalProps));
      }
    },
    toggleModal: (modalProps: ModalProps) => {
      dispatch(toggleModal(modalProps));
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const Summary = connect(
  mapStateToProps,
  mapDispatchToProps
)(SummaryComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/summary/summary.container.ts